// @flow

import React from 'react';
import { Link as GatsbyLink, Node } from 'gatsby';
import styled from 'styled-components';
import { Location } from '@reach/router';

export type LinkProps = {
  url?: string,
  label?: string,
  sameTab?: boolean,
  external?: boolean,
  optimizeEvent?: string | boolean,
  children?: Node,
  onClick?: () => void,
};

const Button = styled.button``;

const StyledLink = styled.a``;

const Link = ({ url, label = null, sameTab, external, children, optimizeEvent = false, ...rest }: LinkProps) =>
  url ? (
    <>
      {external || url.includes('//') || url.includes(':') ? (
        <StyledLink href={url} aria-label={label} rel="noopener noreferrer" target={sameTab ? null : `_blank`} {...rest}>
          {children}
        </StyledLink>
      ) : url.startsWith('#') ? (
        <Location>
          {({ location: { pathname } }) => (
            <GatsbyLink aria-label={label} to={`${pathname}${url}`} {...rest}>
              {children}
            </GatsbyLink>
          )}
        </Location>
      ) : (
        <GatsbyLink aria-label={label} to={url} {...rest}>
          {children}
        </GatsbyLink>
      )}
    </>
  ) : (
    <Button type="button" aria-label={label} {...rest}>
      {children}
    </Button>
  );

export default Link;
